const loadMoreElement = document.querySelector('.load-more');
const { loading: loadingText, loadMore: loadMoreText } = window.accessibilityStrings || {};
const gridElement = document.querySelector('[data-grid]');

loadMoreElement.addEventListener('click', async () => {
  loadMoreElement.textContent = loadingText;
  const nextUrl = loadMoreElement.dataset.nextUrl;

  try {
    const response = await fetch(nextUrl);
    if (!response.ok) throw new Error(`Response status: ${response.status}`);

    const html = await response.text();
    const parser = new DOMParser();
    const newDocument = parser.parseFromString(html, 'text/html');
    const newGridContent = newDocument.querySelector('[data-grid]').innerHTML;
    const newNextUrl = newDocument.querySelector('[data-load-more]')?.dataset.nextUrl;

    gridElement.insertAdjacentHTML('beforeend', newGridContent);
    if (newNextUrl) {
      loadMoreElement.dataset.nextUrl = newNextUrl;
      loadMoreElement.textContent = loadMoreText;
    } else {
      loadMoreElement.remove();
    }
  } catch (error) {
    console.error(error);
    loadMoreElement.textContent = loadMoreText;
  }
});
